import { render, staticRenderFns } from "./_forgotten-password.vue?vue&type=template&id=6b0e7e7a"
import script from "./_forgotten-password.vue?vue&type=script&lang=js"
export * from "./_forgotten-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports